import React from 'react'
import CustomAddForm from '../../version-4/MasterForms/CustomAddForm'

export default function TaxForm({ form, setForm }) {
  const { name, taxValue, taxCode } = form

  const inputField = [
    { label: 'Tax Code', value: taxCode, name: 'taxCode' },
    { label: 'Name', value: name, name: 'name' },
    { label: 'Tax Value', value: taxValue, name: 'taxValue', number: true },
  ]

  return <CustomAddForm state={form} setState={setForm} data={inputField} />
}
